import { lazy as o } from "react";
const r = /* @__PURE__ */ new Map([
  ["Figure", o(() => import("./components/CarouselSlide/slide-layouts/Figure/index.js"))],
  ["ImageCard", o(() => import("./components/CarouselSlide/slide-layouts/ImageCard/index.js"))],
  ["NetworkCalloutSlide", o(() => import("./components/CarouselSlide/slide-layouts/NetworkCallout/index.js"))],
  ["ShowSlide", o(() => import("./components/CarouselSlide/slide-layouts/Show/index.js"))],
  ["TextSlide", o(() => import("./components/CarouselSlide/slide-layouts/Text/index.js"))],
  ["TwoColumnSlide", o(() => import("./components/CarouselSlide/slide-layouts/TwoColumn/index.js"))]
]), i = /* @__PURE__ */ new Map([
  ["ImageOnlyHero", o(() => import("./components/PageHero/page-hero-layouts/ImageOnly/index.js"))],
  ["IONShowHero", o(() => import("./components/PageHero/page-hero-layouts/IONShow/index.js"))],
  ["ContentHero", o(() => import("./components/PageHero/page-hero-layouts/ContentHero/index.js"))]
]), e = /* @__PURE__ */ new Map([
  ["AdBlock", o(() => import("./components/AdBlock/index.js"))],
  ["CtaBlock", o(() => import("./components/CtaBlock/index.js"))],
  ["Figure", o(() => import("./components/Figure/index.js"))],
  ["ImageCard", o(() => import("./components/ImageCard/index.js"))],
  ["MultiLayeredFigure", o(() => import("./components/MultiLayeredFigure/index.js"))],
  ["PromotionsRowBlock", o(() => import("./components/PromotionsRowBlock/index.js"))],
  ["PromotionBlock", o(() => import("./components/PromotionBlock/index.js"))],
  ["CastInfoLayout", o(() => import("./components/CastInfoLayout/index.js"))],
  ["BCVideoPlayer", o(() => import("./components/BCVideoPlayer/index.js"))],
  ["GenericList", o(() => import("./components/GenericList/index.js"))],
  ["Loading", o(() => import("./components/Loading/index.js"))]
]);
export {
  e as blockLayoutsMap,
  i as pageHeroLayoutsMap,
  r as slideLayoutsMap
};
